module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Bold.a368ee1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNextLTPro-Bold.svg
// module id = 228
// module chunks = 0